// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__6uj2T","opacity-transition":"success_opacity-transition__c4ehk"};